<template>
    <div class="card card-dashboard" :class="cardClass">
        <div class="card-header" v-if="icon !== undefined">
            <font-awesome-icon :icon="icon"/>
        </div>
        <div class="card-header" v-if="value !== undefined">
            {{value}}
        </div>
        <div class="card-footer">
            {{text}}
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            icon: {
                type: String,
                required: false
            },
            value: {
                type: String | Number,
                required: false
            },
            text: {
                type: String,
                required: true
            },
            cardClass: {
                type: String,
                'default': 'bg-primary'
            }
        }
    }
</script>
<style lang="scss">
    .card-dashboard {
        text-align: center;
        padding: 20px 10px;
        border-width: 0;
        text-decoration: none ! important;

        .card-footer {
            background: transparent;
            border-width: 0;
            color: #fff;
            padding: 0;
        }
        .card-header {
            background: transparent;
            border-width: 0;
            color: #fff;
            font-size: 2rem;
            line-height: 2rem;
            padding: 0;
            max-height: 32px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/admin/Components/Dashboard/DashboardCard.vue